import { create } from '@bufbuild/protobuf';

import { wsAppRequestManager } from 'APP/wsApi/wsAppApi/WsAppApi';
import { WsRequest } from 'APP/wsApi/wsAppApi/requests/request.types';
import {
  RegisterPushTokenRequest,
  RegisterPushTokenRequestSchema,
  UnregisterPushTokensRequest,
  UnregisterPushTokensRequestSchema,
} from 'APP/wsApi/wsAppApi/types/notifications/notification_request_pb';
import { PushTokenResponse } from 'APP/wsApi/wsAppApi/types/notifications/notification_response_pb';

export function registerPushTokenRequest(
  data: WsRequest<RegisterPushTokenRequest>
): Promise<PushTokenResponse> {
  return wsAppRequestManager.request<PushTokenResponse>({
    case: 'registerPushToken',
    value: create(RegisterPushTokenRequestSchema, data),
  });
}

export function unregisterPushTokensRequest(
  data: WsRequest<UnregisterPushTokensRequest>
): Promise<PushTokenResponse> {
  return wsAppRequestManager.request<PushTokenResponse>({
    case: 'unregisterPushTokens',
    value: create(UnregisterPushTokensRequestSchema, data),
  });
}
